export const AMAZON_KEYWORD_MAX_LENGTH = 80;
export const AMAZON_KEYWORD_MAX_WORDS = 10;

/**
 * Rewrites a keyword into text Amazon SP accepts, or null when it cannot be used.
 * Amazon publishes no pattern; these rules come from a real create (2026-10-16) where
 * `%` `,` `/` `’`, a period outside a number, a lone `+` and more than 10 words were
 * rejected, while `400+`, `3.0hp`, `2-in-1`, `&`, `'` and non-Latin letters were accepted.
 */
export function toAmazonKeywordText(raw: string): string | null {
  const text = raw
    .replace(/[‘’`´]/g, "'")
    .replace(/(?<!\d)\.|\.(?!\d)/g, " ")
    .replace(/[^\p{L}\p{N}\s'&+.-]/gu, " ")
    .replace(/(?<=^|\s)[+-]+(?=\s|$)/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!/[\p{L}\p{N}]/u.test(text) || text.length > AMAZON_KEYWORD_MAX_LENGTH) return null;
  if (text.split(" ").length > AMAZON_KEYWORD_MAX_WORDS) return null;
  return text;
}

/** Dedupe key shared by the client editor and the server import/merge (keywords.duplicate). */
export function keywordKey(text: string): string {
  return text.trim().toLowerCase();
}
